// src/App.js
import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import Reproducteur from './pages/Reproducteur';
import Conditions from './pages/Conditions';
import Tarifs from './pages/Tarifs';
import Galerie from './pages/Galerie';
import Disponibilites from './pages/Disponibilites';
import Temoignages from './pages/Temoignages';
import Infos from './pages/Infos';
import Contact from './pages/Contact';

// ⬇️ AJOUT : composant interne pour remonter en haut à chaque changement de route
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <BrowserRouter>

        {/* Active le scroll automatique */}
        <ScrollToTop />

        <Header />

        {/* Décale tout le contenu pour ne pas passer sous le header fixe */}
        <main className="pt-24 md:pt-28">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reproducteur" element={<Reproducteur />} />
            <Route path="/conditions" element={<Conditions />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/disponibilites" element={<Disponibilites />} />
            <Route path="/temoignages" element={<Temoignages />} />
            <Route path="/infos" element={<Infos />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
